import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1WycinkaAlpinistyczna from "../../components/offer/1wycinkaAlpinistyczna";

function K1WycinkaAlpinistyczna() {
  return (
    <>
      <Helmet>
        <title>Wycinka drzew metodą alpinistyczną w trudnym terenie | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Wycinka drzew metodą alpinistyczną w trudnym terenie | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Bezpieczna wycinka drzew metodą alpinistyczną (sekcyjną) przy liniach energetycznych i budynkach. Realizacje w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Wycinka drzew metodą alpinistyczną w trudnym terenie | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Bezpieczna wycinka drzew metodą alpinistyczną (sekcyjną) przy liniach energetycznych i budynkach. Realizacje w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1WycinkaAlpinistyczna />
      </main>
      <Footer />
    </>
  );
}
export default K1WycinkaAlpinistyczna;
